// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"GuidePageFloatWidget_wrapper__1IewD","inDesktop":"GuidePageFloatWidget_inDesktop__2xlAn"};